<template>
  <NConfigProvider>
    <NScrollbar
      ref="scrollbarRef"
      style="max-height: 100vh"
      x-scrollable
      :on-scroll="handleScroll"
    >
      <HeaderComponent
        :scrollTop="scrollTop"
        @updateScrollTop="handleScrollTop"
      />
      <NMessageProvider>
        <router-view />
      </NMessageProvider>
      <FooterComponent />
    </NScrollbar>
  </NConfigProvider>
</template>

<script lang="ts">
import { NScrollbar, NMessageProvider, NConfigProvider } from "naive-ui";
import HeaderComponent from "@/components/header.vue";
import FooterComponent from "@/components/footer.vue";
import {
  ref,
  defineComponent,
  toRefs,
  reactive,
  getCurrentInstance,
  onMounted,
} from "vue";

export default defineComponent({
  components: {
    HeaderComponent,
    FooterComponent,
    NScrollbar,
    NMessageProvider,
    NConfigProvider,
  },
  setup() {
    const { proxy } = getCurrentInstance() as any;
    const scrollbarRef = ref();
    const state = reactive({
      scrollTop: 0,
    });
    const handleScroll = (val: any) => {
     
      state.scrollTop = val.srcElement.scrollTop;
    };
 

    const handleScrollTop = () => {
      setTimeout(() => {
        scrollbarRef.value.scrollTo({ top: 0 });
      }, 0);
    };
    onMounted(() => {});
    return {
      scrollbarRef,
      handleScrollTop,
      handleScroll,
      ...toRefs(state),
    };
  },
});
</script>

<style>
body {
  padding: 0;
  margin: 0;
  background-color: #f4f6f7;
}
</style>
